module.exports = __webpack_public_path__ + "static/media/amarelo.e5556a75.svg";